// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"319":"7f6b4307","408":"6bd22674","477":"22b071e8","636":"f819e7db","641":"704fd316","671":"c09caced","831":"0c12736f"}[chunkId] + ".chunk.js";
};